import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/agenda";

/**
 * Classe de gerenciamento de chamadas da API do ProcedimentoPlanoOperadora
 *
 * @class
 */
export default class AgendaApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe AgendaApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
 * @returns registro da agenda
 */
  BuscarAgendas(codUnidade: number, dataInicial: string, dataFinal: string, itensPeriodo: boolean) {
    return this.api<ApplicationModule[]>(`${controller}/listar-combo`, {
      method: "GET",
      params: { codUnidade, dataInicial, dataFinal, itensPeriodo }
    });
  }

}